Ext.define('SA.view.quickreport.QuickReportHeaderCellMenu', {
    alias: 'quickreport.header-cell-menu',
    extend: 'SA.view.quickreport.QuickReportCellMenu',

    getConfig(params) {
        var cfg = this.callParent(arguments),
            location = params.location;

        cfg.items.push(
            {
                xtype: 'component',
                cls: 'sa-quick-report-cell-menu-caption',
                html: this.getLocationCaptionHtml(location)
            }, {
                xtype: 'menu-add-remove-favorite-location',
                location
            }, {
                xtype: 'menu-set-location-alias',
                location
            }, {
                xtype: 'menu-remove-location',
                location
            }
        );

        return cfg;
    }
});